import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Team",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getTeam, getTeamError, getTeamSuccess } = slice.actions;

reducerRegistry.register("team", reducer);
